import React from 'react';

function Footer() {
  return (
    <footer>
      <div className="footer-content">
        
        <div className="footer-section">
          <h4>Навигация по сайту</h4>
          <ul>
            <li className="ul-footer"><a href="#">О ресурсе</a></li>
            <li className="ul-footer"><a href="#categories">Наши услуги</a></li>
            <li className="ul-footer"><a href="#aboutus">О нас</a></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Контакты</h4>
          <p>
            <img src="images/mail.png" alt="Email" /> enjoybymap@gmail.com
          </p>
          <p>
            <img src="images/phone.png" alt="Phone" /> +375 (29) 869-19-59
          </p>
        </div>
        
      </div>
    </footer>
  );
}

export default Footer;